import { template as template_e6618110867940fb8c771ae9f41f480e } from "@ember/template-compiler";
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import DynamicObjectConfig from 'eflex/components/inputs/dynamic-object-config';
import CheckboxInput from 'eflex/components/checkbox-input';
import { isPresent } from '@eflexsystems/ember-composable-helpers';
export default class ToolPropertiesDynamicObjectConfigToggle extends Component {
    @tracked
    toggled = null;
    get isToggled() {
        return this.toggled === null ? isPresent(this.args.dynamicObjectName) : this.toggled;
    }
    toggle = (toggle)=>{
        if (!toggle) {
            this.args.updateObjectName(null);
        }
        this.toggled = toggle;
    };
    static{
        template_e6618110867940fb8c771ae9f41f480e(`
    <div class="row flex-column gy-3">
      <div class="d-flex align-items-center">
        <CheckboxInput
          class="toggle-dynamic-object {{if this.isToggled "toggled"}}"
          @disabled={{@disabled}}
          @checked={{this.isToggled}}
          @onChange={{this.toggle}}
        />
        <span class="fw-bold lh-1 {{if @disabled "opacity-25"}}">
          {{t "workInstructions.dynamicObject"}}
        </span>
      </div>
      {{#if this.isToggled}}
        <div class="col-auto">
          <DynamicObjectConfig
            @dynamicObjectName={{@dynamicObjectName}}
            @startHidden={{@startHidden}}
            @updateObjectName={{@updateObjectName}}
            @updateStartHidden={{@updateStartHidden}}
            @disabled={{@disabled}}
          />
        </div>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
